import { createFileRoute } from "@tanstack/react-router";
import { CreateLeagueForm } from "@/features/leagues/components/CreateLeagueForm";
import { useT } from "@/shared/i18n";
import { PageContainer } from "@/shared/layout/PageContainer";
import { PageHeader } from "@/shared/layout/PageHeader";

export const Route = createFileRoute("/_authenticated/leagues/new")({
  component: NewLeaguePage,
});

function NewLeaguePage() {
  const t = useT();
  return (
    <PageContainer width="narrow">
      <PageHeader
        eyebrow={t("nav.league")}
        title={t("create.title")}
        subtitle={t("create.subtitle")}
      />
      <CreateLeagueForm />
    </PageContainer>
  );
}
